export const getIsValidDatePrefix = (value: string) => {
  const monthAbbreviations = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const ordinalSuffixes = ["st", "nd", "rd", "th"];

  const generateRegexPatterns = (words: string[]): string => {
    const prefixes = new Set<string>();
    for (const word of words) {
      for (let i = 1; i <= word.length; i++) {
        prefixes.add(word.substring(0, i));
      }
    }
    const prefixArray = Array.from(prefixes);
    prefixArray.sort((a, b) => b.length - a.length);

    return `(${prefixArray.join("|")})`;
  };

  const monthAbbrRegex = generateRegexPatterns(monthAbbreviations);
  const monthNameRegex = generateRegexPatterns(monthNames);
  const ordinalSuffixRegex = generateRegexPatterns(ordinalSuffixes);

  const datePrefixRegexes = [
    // "yyyy-MM-dd"
    /^\d{0,4}(-\d{0,2}(-\d{0,2})?)?$/,

    // "MMM do, yyyy"
    new RegExp(
      `^${monthAbbrRegex}( \\d{0,2}${ordinalSuffixRegex})?(, ?\\d{0,4})?$`,
      "i"
    ),

    // "MMMM do, yyyy"
    new RegExp(
      `^${monthNameRegex}( \\d{0,2}${ordinalSuffixRegex})?(, ?\\d{0,4})?$`,
      "i"
    ),

    // "MM/dd/yyyy"
    /^\d{0,2}(\/\d{0,2}(\/\d{0,4})?)?$/,

    // "MM-dd-yyyy"
    /^\d{0,2}(-\d{0,2}(-\d{0,4})?)?$/,

    // "MMMM d, yyyy"
    new RegExp(`^${monthNameRegex}( \\d{0,2})?(, ?\\d{0,4})?$`, "i"),

    // "MMM d, yyyy"
    new RegExp(`^${monthAbbrRegex}( \\d{0,2})?(, ?\\d{0,4})?$`, "i"),

    // "yyyy/MM/dd"
    /^\d{0,4}(\/\d{0,2}(\/\d{0,2})?)?$/,

    // "d/M/yyyy"
    /^\d{0,2}(\/\d{0,2}(\/\d{0,4})?)?$/,
  ];

  return (
    datePrefixRegexes.some((regex) => regex.test(value)) && value.length <= 20
  );
};
